import React from 'react';
import { RemoveInstallationForm } from 'modules/components/layer12';
import { BasicFormModalLayout } from 'modules/components/layer13';

export type RemoveInstallationModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
  preventNavigation?: boolean;
};

export const FC = (props: RemoveInstallationModalProps) => {

  return (
    <BasicFormModalLayout.FC
      id={props.id}
      title='Remove installation'
      subTitle='Confirm you want to remove the Selection.'
      handleClose={props.handleClose}
      isVisible={props.isVisible}
    >
      <RemoveInstallationForm.FC
        id={props.id}
        handleClose={props.handleClose}
        preventNavigation={props.preventNavigation ?? false}
      />
    </BasicFormModalLayout.FC>
  );

};
